import { h, Component } from 'preact';
import Border from '../border/border';
import Content from '../content/content';
import styles from './products.css';

export default class Products extends Component {
  state = {
    hoverSubscription: false,
    hoverOneOff: false
  }

  renderSubscription() {
    const { hoverSubscription } = this.state;
    const image = hoverSubscription
      ? '/assets/subscription-hover.png'
      : '/assets/subscription.png';
    return (<div>
      <img src="/assets/text-go-with.png" className={styles.goWithText} />
      <a href="#page-subscription">
        <img className={styles.subscription}
        src={image}
        onMouseEnter={() => this.setState({ hoverSubscription: true })}
        onMouseLeave={() => this.setState({ hoverSubscription: false })} />
        </a>
    </div>);
  }

  renderOneOff() {
    const { hoverOneOff } = this.state;
    const image = hoverOneOff
      ? '/assets/oneoff-hover.png'
      : '/assets/oneoff.png';

    return (<div>
      <img src="/assets/text-or-this.png" className={styles.orText} />
      <a href="#page-one-off">
        <img className={styles.oneOff}
        src={image}
        onMouseEnter={() => this.setState({ hoverOneOff: true })}
        onMouseLeave={() => this.setState({ hoverOneOff: false })}/>
      </a>
      </div>);
  }

  render() {
    return (<div className={styles.container} id="page-products">
      <Content>
        <div className={`flex ${styles.content}`}>
          <div className={`flex ${styles.productContainer}`}>
            {this.renderSubscription()}
            {this.renderOneOff()}
          </div>
          <div>
            <h2 className={styles.title}>Our products</h2>
            <h3 className={styles.subTitle}>What we provide</h3>
            <p>Whether it’s providing a portable bar and kegs for your office, or producing cases of branded beer bottles for a memorable event, we’ve got you covered.</p>
            <p>Our wide range of beers and flavours ensure we’ve got something for everyone. And because we brew right here in Singapore, we’re able to get it to you quickly.</p>
        </div>
        </div>
      </Content>
      <Border color="white" />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./components/products/products.jsx